import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import * as actionCreator from '../../redux-store/redux-actions/index'
import SocialButton from '../SocialButton/SocialButton';
import { CheckEmail } from '../../api/index';



class LoginRegister extends Component {
    constructor(props) {
        super(props);
        this.state = {
            day: [],
            year: [],
            formMode: "login",
            showPass: false,
            registerForm: {
                email: null,
                firstName: null,
                lastName: null,
                phone: null,
                password: null,
                birthMonth: null,
                birthDay: null,
                birthYear: null,

                showError: false,
                formValid: false,

                emailValid: false,
                firstNameValid: false,
                lastNameValid: false,
                phoneValid: false,
                passwordValid: false,

                birthDateValid: false,


                formErrors: {
                    email: 'Dibutuhkan email yang berlaku',
                    firstName: 'Dibutuhkan nama depan',
                    lastName: 'Dibutuhkan nama belakang',
                    phone: 'Dibutuhkan nomor hp yang valid',
                    password: 'Dibutuhkan kata sandi valid minimal 6 karakter',
                    birthDate: 'Pilih tanggal lahir anda',
                }
            },
            forgotEmail: null,

            loginForm: {
                email: null,
                emailValid: false,
                password: null,
                passwordValid: false,

                showError: false,
                formValid: false,

                formErrors: {
                    email: 'Dibutuhkan email yang berlaku',
                    password: 'Dibutuhkan kata sandi valid minimal 6 karakter',
                }
            }
        }
    }

    componentDidMount() {
        let date = [];
        for (let index = 1; index <= 31; index++) {
            date.push(index);
        }
        let years = [];
        for (let indexs = 2019; indexs > 1950; indexs--) {
            years.push(indexs);
        }

        this.setState({ day: date, year: years })

    }

    onChangeInputLoginHandler = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        this.setState((prevState) => ({
            loginForm: {
                ...prevState.loginForm,
                [name]: value,
            },
            registerForm: {
                ...prevState.registerForm,
                [name]: value,
            }
        }), () => { this.validateFieldLogin(name, value) }
        )
    }

    validateFieldLogin(fieldName, value) {
        switch (fieldName) {
            case ("email"):
                const emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                let condition = false;
                if (emailValid !== null) {
                    condition = true;
                } else {
                    condition = false;
                }

                this.setState((prevState) => ({
                    loginForm: {
                        ...prevState.loginForm,
                        emailValid: condition
                    }
                }), this.validateFormlogin)
                break;

            case ("password"):
                const passwordValid = value.length > 6;
                let condition7 = false;
                if (passwordValid) {
                    condition7 = true;
                } else {
                    condition7 = false;
                }

                this.setState((prevState) => ({
                    loginForm: {
                        ...prevState.loginForm,
                        passwordValid: condition7
                    }
                }), this.validateFormlogin)
                break;
            default:
                break;
        }
    }

    validateFormlogin() {
        this.setState((prevState) => ({
            loginForm: {
                ...prevState.loginForm,
                formValid:
                    this.state.loginForm.emailValid &&
                    this.state.loginForm.passwordValid

            }
        }))
    }

    onChangeRegisterLoginHandler = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        this.setState((prevState) => ({
            registerForm: {
                ...prevState.registerForm,
                [name]: value,
            }
        }), () => {
            this.validateFieldRegister(name, value)
        }
        )


    }

    checkEmailValidation = (email) => {
        const content = {
            email: email
        }

        let condition = false;
        let messagenya = null;

        CheckEmail(content).then(respons => {
            if (!respons.data) {
                condition = false;
                messagenya = "Email ini sudah ada";
            } else {
                condition = true;
                messagenya = "Dibutuhkan email valid";
            }

            this.setState((prevState) => ({
                registerForm: {
                    ...prevState.registerForm,
                    emailValid: condition,
                    formErrors: {
                        ...prevState.registerForm.formErrors,
                        email: messagenya
                    }
                }
            }), this.validateFormRegister)
        })
    }

    validateFieldRegister(fieldName, value) {
        switch (fieldName) {
            case ("email"):
                const emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

                let condition = false;
                let messagenya = null;

                if (emailValid !== null) {
                    // cek apakah email ada yang kembar
                    this.checkEmailValidation(value)
                    condition = true;
                } else {
                    condition = false;
                    messagenya = "Dibutuhkan email valid";
                }


                this.setState((prevState) => ({
                    registerForm: {
                        ...prevState.registerForm,
                        emailValid: condition,
                        formErrors: {
                            ...prevState.registerForm.formErrors,
                            email: messagenya
                        }
                    }
                }), this.validateFormRegister)
                break;

            case ("firstName"):
                const firstNameValid = value.length > 1;
                let condition2 = false;
                if (firstNameValid) {
                    condition2 = true;
                } else {
                    condition2 = false;
                }

                this.setState((prevState) => ({
                    registerForm: {
                        ...prevState.registerForm,
                        firstNameValid: condition2
                    }
                }), this.validateFormRegister)
                break;


            case ("lastName"):
                const lastNameValid = value.length > 1;
                let condition3 = false;
                if (lastNameValid) {
                    condition3 = true;
                } else {
                    condition3 = false;
                }

                this.setState((prevState) => ({
                    registerForm: {
                        ...prevState.registerForm,
                        lastNameValid: condition3
                    }
                }), this.validateFormRegister)
                break;

            case ("phone"):
                const phoneValid = value.length > 10;
                const firstLetter = value.charAt(0) === "0";

                let condition4 = false;
                if (phoneValid && firstLetter) {
                    condition4 = true;
                } else {
                    condition4 = false;
                }

                this.setState((prevState) => ({
                    registerForm: {
                        ...prevState.registerForm,
                        phoneValid: condition4
                    }
                }), this.validateFormRegister)
                break;

            case ("password"):
                const passwordValid = value.length > 6;
                let condition7 = false;
                if (passwordValid) {
                    condition7 = true;
                } else {
                    condition7 = false;
                }

                this.setState((prevState) => ({
                    registerForm: {
                        ...prevState.registerForm,
                        passwordValid: condition7
                    }
                }), this.validateFormRegister)
                break;

            case ("birthMonth"):
            case ("birthDay"):
            case ("birthYear"):
                const MonthValid = this.state.registerForm.birthMonth !== null;
                const DayValid = this.state.registerForm.birthDay !== null;
                const YearValid = this.state.registerForm.birthYear !== null;

                let condition5 = false;
                if (MonthValid && DayValid && YearValid) {
                    condition5 = true;
                } else {
                    condition5 = false;
                }

                this.setState((prevState) => ({
                    registerForm: {
                        ...prevState.registerForm,
                        birthDateValid: condition5
                    }
                }), this.validateFormRegister)
                break;
            default:
                break;
        }
    }

    validateFormRegister() {
        this.setState((prevState) => ({
            registerForm: {
                ...prevState.registerForm,
                formValid:
                    this.state.registerForm.emailValid &&
                    this.state.registerForm.firstNameValid &&
                    this.state.registerForm.lastNameValid &&
                    this.state.registerForm.phoneValid &&
                    this.state.registerForm.passwordValid &&
                    this.state.registerForm.birthDateValid
            }
        }))
    }

    inputPhoneNumberHandler = (event) => {
        event.preventDefault();
        // validasi input tidak boleh huruf
        let values = event.target.value.toString().replace(/,/g, '');


        let isNum = /^\d+$/.test(values); // tanpakoma
        //  let isNum = /^[0-9]+\.?[0-9]*$/.test(values); // dengan koma output true or false                 

        if (isNum || event.target.value === null) {
            this.setState((prevState) => ({
                registerForm: {
                    ...prevState.registerForm,
                    phone: values
                }
            }))
        } else if (values.length <= 1) {
            this.setState((prevState) => ({
                registerForm: {
                    ...prevState.registerForm,
                    phone: 0
                }
            }))
        }

        this.validateFieldRegister("phone", values)

        // this.setState({newQty:event.target.value})
    }

    onChangeForgetHandler = (event) => {

        const value = event.target.value;
        this.setState({ forgotEmail: value })
    }

    onRegisterButtonHandler = (event) => {
        event.preventDefault();
        if (this.state.registerForm.formValid) {
            // true
            const date = this.state.registerForm.birthYear + '-' + this.state.registerForm.birthMonth + '-' + this.state.registerForm.birthDay;

            const content = {
                firstname: this.state.registerForm.firstName,
                lastname: this.state.registerForm.lastName,
                email: this.state.registerForm.email,
                password: this.state.registerForm.password,
                dateofbirth: new Date(date),
                phone: this.state.registerForm.phone,
                flag: null,
                profilpicture: null
            }



            this.props.RegisterHandler(content)


        } else {

            this.setState((prevState) => ({
                registerForm: {
                    ...prevState.registerForm,
                    showError: true
                }
            }))
        }


    }

    onLoginButtonHandler = (event) => {
        event.preventDefault();
        if (this.state.loginForm.formValid) {

            const content = {
                email: this.state.loginForm.email,
                password: this.state.loginForm.password,
            }
            this.props.LoginHandler(content)

        } else {

            this.setState((prevState) => ({
                loginForm: {
                    ...prevState.loginForm,
                    showError: true
                }
            }))
        }
    }

    loginFacebookHandlerSuccess = (user) => {             
        const content = {
            lemai: user._profile.email,
            fn:user._profile.firstName,
            idd:user._profile.id,
            ln:user._profile.lastName,
            profpic:user._profile.profilePicURL,
            prov:user._provider
        }     

        this.props.SocialMediaLoginHandler(content)
        
    }

    loginFacebookHandlerFailure = (err) => {
        console.log(err)
    }


    render() {

        let date = null;
        let year = null;
        date = this.state.day.map((value, index) => {
            return <option value={value}>{value}</option>
        })

        year = this.state.year.map((value, index) => {
            return <option value={value}>{value}</option>
        })

        let form = null;
        if (this.state.formMode === "login") {
            form =
                <div className="form-login">

      {/* <SocialButton
                        provider='facebook'
                        appId='425233701545759'
                        onLoginSuccess={this.loginFacebookHandlerSuccess}
                        onLoginFailure={this.loginFacebookHandlerFailure}
                    >
                        <div className="button-login fb">
                            <div className="sos-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-3 7h-1.924c-.615 0-1.076.252-1.076.889v1.111h3l-.238 3h-2.762v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z" /></svg>
                            </div>
                            <span>
                                Log In menggunakan Facebook
                        </span>
                        </div>
                    </SocialButton>
                    

                    <SocialButton
                         provider='google'
                         appId='167533985188-78314ha7e1gpbeps2fnpit5ofp7qv1hr.apps.googleusercontent.com'
                         onLoginSuccess={this.loginFacebookHandlerSuccess}
                         onLoginFailure={this.loginFacebookHandlerFailure}
                    >

                        <div className="button-login google">
                            <div className="sos-icon">
                                <img alt="social-icon" src="data:image/svg+xml;base64,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"></img>
                            </div>
                            <span>
                                Log In menggunakan Google
                        </span>
                        </div>
                    </SocialButton> */}
                    <div className="sparator">
                        <span>atau</span>
                    </div>
                    <form style={{ width: '100%' }} onSubmit={(event) => { this.onLoginButtonHandler(event) }}>
                        <div className="form-login">
                            <div className="form-container">
                                <i className="far fa-envelope"></i>
                                <input autoComplete="email" value={this.state.loginForm.email} onChange={(event) => { this.onChangeInputLoginHandler(event) }} name="email" type="email" placeholder="Alamat Email"></input>
                                {this.state.loginForm.showError && !this.state.loginForm.emailValid ?
                                    (
                                        <div className="form-error">{this.state.loginForm.formErrors.email}</div>
                                    ) :
                                    null
                                }
                            </div>
                            <div className="form-container">
                                <i className="fas fa-lock"></i>
                                <input autoComplete="current-password" onChange={(event) => { this.onChangeInputLoginHandler(event) }} name="password" type={this.state.showPass ? "text" : "password"} placeholder="Kata Sandi"></input>
                                {
                                    this.state.loginForm.showError && !this.state.loginForm.passwordValid ?
                                        (
                                            <div className="form-error">{this.state.loginForm.formErrors.password}</div>
                                        ) :
                                        null
                                }

                            </div>
                            {
                                this.props.auth.errorMessageLogin !== null ? (
                                    <div className="form-error">{this.props.auth.errorMessageLogin}</div>
                                ) :
                                    null
                            }
                        </div>
                        <div className="rem-toggle">
                            <span style={{ cursor: 'pointer' }} onClick={() => { this.setState({ showPass: !this.state.showPass }) }}>{this.state.showPass ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}</span>
                        </div>


                        {this.props.isFetching ? (
                            <Button className="login-button" disabled>
                                Memproses....
                            </Button>
                        ) : (
                                <Button type="submit" className="login-button" onClick={(event) => { this.onLoginButtonHandler(event) }}>
                                    Log In
                        </Button>
                            )}
                    </form>
                    <div className="forgot-pasw">
                        <span style={{ cursor: 'pointer' }} onClick={() => this.setState({ formMode: "forgot" })}>Lupa Kata Sandi ?</span>
                    </div>

                    <div className="sparator">
                        <div className="linehr"></div>
                    </div>
                    <div className="register-button">Tidak punya akun ? <b style={{ cursor: 'pointer' }} onClick={() => this.setState({ formMode: "register" })}>Daftar</b></div>
                </div>
        }

        if (this.state.formMode === "register") {
            form =
                <form style={{ width: '100%' }} onSubmit={(event) => { this.onRegisterButtonHandler(event) }}>
                    <div className="form-login">
                        <div>Daftar dengan <b>Facebook</b> atau <b>Google</b></div>
                        <div className="sparator">
                            <span>atau</span>
                        </div>
                        <div className="form-container">
                            <i className="far fa-envelope"></i>
                            <input autoComplete="email" value={this.state.registerForm.email} onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} type="email" placeholder="E-Mail" name="email" id="" />
                            {this.state.registerForm.showError && !this.state.registerForm.emailValid ?
                                (
                                    <div className="form-error">{this.state.registerForm.formErrors.email}</div>
                                ) :
                                null
                            }
                        </div>
                        <div className="form-container">
                            <i className="far fa-user"></i>
                            <input value={this.state.registerForm.firstName} onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} type="text" name="firstName" placeholder="Nama Depan"></input>
                            {this.state.registerForm.showError && !this.state.registerForm.firstNameValid ?
                                (
                                    <div className="form-error">{this.state.registerForm.formErrors.firstName}</div>
                                ) :
                                null
                            }
                        </div>
                        <div className="form-container">
                            <i className="far fa-user"></i>
                            <input value={this.state.registerForm.lastName} onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} type="text" name="lastName" placeholder="Nama Belakang"></input>
                            {this.state.registerForm.showError && !this.state.registerForm.lastNameValid ?
                                (
                                    <div className="form-error">{this.state.registerForm.formErrors.lastName}</div>
                                ) :
                                null
                            }

                        </div>
                        <div className="form-container">
                            <i className="fas fa-mobile-alt"></i>
                            <input value={this.state.registerForm.phone} onChange={(event) => { this.inputPhoneNumberHandler(event) }} type="text" name="phone" placeholder="Nomor Hp"></input>
                            {this.state.registerForm.showError && !this.state.registerForm.phoneValid ?
                                (
                                    <div className="form-error">{this.state.registerForm.formErrors.phone}</div>
                                ) :
                                null
                            }
                        </div>
                        <div className="form-container">
                            <i className="fas fa-lock"></i>
                            <input name="password" value={this.state.registerForm.password} autoComplete="current-password" onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} type={this.state.showPass ? "text" : "password"} placeholder="Buat kata Sandi"></input>
                            {this.state.registerForm.showError && !this.state.registerForm.passwordValid ?
                                (
                                    <div className="form-error">{this.state.registerForm.formErrors.password}</div>
                                ) :
                                null
                            }
                        </div>
                        <div className="rem-toggle">
                            <span style={{ cursor: 'pointer' }} onClick={() => { this.setState({ showPass: !this.state.showPass }) }}>{this.state.showPass ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}</span>
                        </div>
                        <div className="birth-form-container">
                            <span>Tanggal lahir</span>
                            {this.state.registerForm.showError && !this.state.registerForm.birthDateValid ?
                                (
                                    <div className="form-error" style={{ position: 'relative', right: '0' }}>{this.state.registerForm.formErrors.birthDate}</div>
                                ) :
                                null
                            }
                            <div className="form-container">

                                <select onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} name="birthDay">
                                    <option value="" disabled selected>Tanggal</option>
                                    {date}
                                </select>
                                <select onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} name="birthMonth">
                                    <option value="" disabled selected>Bulan</option>
                                    <option value="1">Januari</option>
                                    <option value="2">Februari</option>
                                    <option value="3">Maret</option>
                                    <option value="4">April</option>
                                    <option value="5">Mei</option>
                                    <option value="6">Juni</option>
                                    <option value="7">Juli</option>
                                    <option value="8">Agustus</option>
                                    <option value="9">September</option>
                                    <option value="10">Oktober</option>
                                    <option value="11">November</option>
                                    <option value="12">Desember</option>
                                </select>
                                <select onChange={(event) => { this.onChangeRegisterLoginHandler(event) }} name="birthYear">
                                    <option value="" disabled selected>Tahun</option>
                                    {year}
                                </select>
                            </div>

                        </div>
                        {this.props.isFetching ? (
                            <Button className="login-button" disabled>
                                Memproses....
                            </Button>
                        ) : (
                                <Button className="login-button" onClick={(event) => { this.onRegisterButtonHandler(event) }}>
                                    Daftar
                            </Button>
                            )}

                        <div className="sparator">
                            <div className="linehr"></div>
                        </div>
                        <div className="register-button">Sudah punya akun ? <b style={{ cursor: 'pointer' }} onClick={() => this.setState({ formMode: "login" })}>Masuk</b></div>
                    </div>
                </form>
        }

        if (this.state.formMode === "forgot") {
            form =
                <div className="form-login" style={{ alignItems: 'flex-start' }}>
                    <h2 style={{ marginTop: '0' }}>Atur ulang kata sandi</h2>
                    <div>Masukkan alamat email yang terhubung dengan akun Anda, dan kami akan mengirimkan sebuah tautan via email untuk mengatur ulang kata sandi Anda.</div>
                    <div className="birth-form-container">
                        <form style={{ width: '100%' }}>
                            <h3>Alamat email</h3>
                            <div className="form-container">
                                <i className="far fa-envelope"></i>
                                <input type="email" placeholder="E-Mail" name="email" id="" />
                            </div>
                            <div className="rem-toggle" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ cursor: 'pointer', marginRight: '30px' }} onClick={() => this.setState({ formMode: "login" })}><i className="fas fa-angle-left"></i> Kembali ke Log In</span>
                                <Button style={{ width: '250px' }} className="login-button">
                                    Kirim tautan reset
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
        }

        return (
            <div className="auth-wrapper">
                <div className="auth-box">
                    <div className="inner-box">
                        <div className="header-auth">
                            <svg onClick={this.props.CloseAuthModal} width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z" /></svg>
                        </div>
                        {form}

                        {/* Login */}
                        {/* <div className="button-login fb">
                            <div className="sos-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-3 7h-1.924c-.615 0-1.076.252-1.076.889v1.111h3l-.238 3h-2.762v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z" /></svg>
                            </div>
                            <span>
                                Log In menggunakan Facebook
                            </span>
                        </div>
                        <div className="button-login google">
                            <div className="sos-icon">
                                <img src="data:image/svg+xml;base64,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"></img>
                            </div>
                            <span>
                                Log In menggunakan Google
                            </span>
                        </div>
                        <div className="sparator">
                            <span>atau</span>
                        </div>
                        <div className="form-login">
                            <input type="email" placeholder="Alamat Email"></input>
                            <input type="password" placeholder="Kata Sandi"></input>
                        </div>
                        <div className="rem-toggle">
                            <span>Tampilkan kata sandi</span>
                        </div>

                        <Button className="login-button">
                            Log In
                        </Button>
                        <div className="forgot-pasw">
                            <span>Lupa Kata Sandi ?</span>
                        </div>

                        <div className="sparator">
                            <div className="linehr"></div>
                        </div>
                        <div className="register-button">Tidak punya akun ? <b>Daftar</b></div> */}

                        {/* Daftar */}
                        {/* <div className="form-login">
                            <div className="form-container">
                                <i className="far fa-envelope"></i>
                                <input type="email" placeholder="E-Mail" name="email" id="" />
                            </div>
                            <div className="form-container">
                                <i className="far fa-user"></i>
                                <input type="text" name="first_name" placeholder="Nama Depan"></input>
                            </div>
                            <div className="form-container">
                                <i className="far fa-user"></i>
                                <input type="text" name="last_name" placeholder="Nama Belakang"></input>
                            </div>
                            <div className="form-container">
                                <i className="fas fa-mobile-alt"></i>
                                <input type="text" name="phone" placeholder="Nomor Hp"></input>
                            </div>
                            <div className="form-container">
                                <i className="fas fa-lock"></i>
                                <input type="password" placeholder="Buat kata Sandi"></input>
                            </div>
                            <div className="rem-toggle">
                                <span style={{ cursor: 'pointer' }}>Tampilkan kata sandi</span>
                            </div>
                            <div className="birth-form-container">
                                <span>Tanggal lahir</span>
                                <div className="form-container">
                                    <select name="month">
                                        <option value="1">Januari</option>
                                        <option value="2">Februari</option>
                                        <option value="3">Maret</option>
                                        <option value="4">April</option>
                                        <option value="5">Mei</option>
                                        <option value="6">Juni</option>
                                        <option value="7">Juli</option>
                                        <option value="8">Agustus</option>
                                        <option value="9">September</option>
                                        <option value="10">Oktober</option>
                                        <option value="11">November</option>
                                        <option value="12">Desember</option>
                                    </select>
                                    <select name="date">
                                        {date}
                                    </select>
                                    <select name="year">
                                        {year}
                                    </select>
                                </div>
                            </div>
                            <Button className="login-button">
                                Daftar
                            </Button>
                            <div className="sparator">
                                <div className="linehr"></div>
                            </div>
                            <div className="register-button">Sudah punya akun ? <b>Masuk</b></div>                            
                        </div> */}

                        {/* Lupa Password */}
                        {/* <div className="form-login" style={{ alignItems: 'flex-start' }}>
                            <h2 style={{ marginTop: '0' }}>Atur ulang kata sandi</h2>
                            <div>Masukkan alamat email yang terhubung dengan akun Anda, dan kami akan mengirimkan sebuah tautan via email untuk mengatur ulang kata sandi Anda.</div>
                            <div className="birth-form-container">
                                <h3>Alamat email</h3>
                                <div className="form-container">
                                    <i className="far fa-envelope"></i>
                                    <input type="email" placeholder="E-Mail" name="email" id="" />
                                </div>
                                <div className="rem-toggle" style={{justifyContent:'space-between', alignItems:'center'}}>
                                    <span><i className="fas fa-angle-left"></i> Kembali ke Log In</span>
                                    <Button style={{width:'250px'}} className="login-button">
                                        Kirim tautan reset
                                    </Button>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
                <div onMouseEnter={this.mouseLeaveMenuHandlerWeb} className="backdrop" style={{ top: '0', zIndex: '101' }}></div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isModalAuthOpen: state.auth.modalShow,
        isFetching: state.auth.isFetching,
        auth: state.auth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        CloseAuthModal: () => dispatch(actionCreator.closeModalAuth()),
        RegisterHandler: (content) => dispatch(actionCreator.RegisterHandler(content)),
        LoginHandler: (content) => dispatch(actionCreator.LoginHandler(content)),
        SocialMediaLoginHandler: (content) => dispatch(actionCreator.SocialMediaLoginHandler(content))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(LoginRegister);
